import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto"; // Import ChartJS for necessary setup
import { convertNumber } from "../../../functions/convertNumber";

/**
 * LineChart component renders a line chart using the React Chart.js library.
 * @param {Object} chartData - Data object containing datasets for the chart.
 * @param {string} chartType - Type of chart, either "prices" or other.
 * @param {boolean} multiAxis - Flag to determine if multiple Y-axes should be displayed.
 * @returns {JSX.Element} - Line chart component.
 */
function LineChart({ chartData, chartType, multiAxis }) {
  // Chart options configuration
  const options = {
    plugins: {
      legend: {
        display: multiAxis ? true : false, // Display legend based on multiAxis flag
      },
    },
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      crypto1: {
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, ticks) {
            if (chartType === "prices") return "$" + value.toLocaleString();
            else {
              return "$" + convertNumber(value);
            }
          },
        },
      },
      crypto2: {
        type: "linear",
        display: true,
        position: "right",
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, ticks) {
            if (chartType === "prices") return "$" + value.toLocaleString();
            else {
              return "$" + convertNumber(value);
            }
          },
        },
      },
    },
  };

  // Render the Line chart component
  return <Line data={chartData} options={options} />;
}

export default LineChart;
